<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null">
        <span class="text">{{ msgAlerta }}</span>
    </div>


    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Código</th>
                <th>Nome/Descrição</th>
                <th>Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdtipo) }}</td>
                    <td>{{ obj.nmtipo }}</td>
                    <td class="col-width-char30 center">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdperfil) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <input type="text" v-model="objEdicao.nmtipo" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Ativo</label>
                    <select v-model="objEdicao.ativo">
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                    </select>
                </div>
            </div>
            

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Informações</label>
                    <textarea v-model="objEdicao.detalhamento" maxlength="3000" rows="5" style="resize: none;"/>
                </div>
            </div>


            <div class="row-end row-space">
                <label for="ckcidadao">Permitir Aplicativo Cidadão</label>
                <input type="checkbox" class="input-checkbox" id="ckcidadao" v-model="objEdicao.ckcidadao" true-value="S" false-value="N" />
            </div>


            <div class="row-end">
                <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
                <button type="button" class="btn-cancel" @click="modoEdicao=false">Cancelar</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { criarManifTipo } from '@/models/ManifTipo';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close']);

const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const objEdicao = ref(criarManifTipo());

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


function editarCadastro(obj) {
    setEdicao(obj.id);
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/manif_tipo', {
            idmunicipio: globalStore.idmunicipio,
            nmpesquisar: nmPesquisa.value,
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value = false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        const response  = await Api.genericPut('/cad/manif_tipo', objEdicao.value);
        if (response.bolok === 1){
            await lerDados();
            modoEdicao.value = false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function setEdicao(idEdicao) {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (idEdicao > 0) {
            const req = await Api.getCadastroById('manif_tipo', idEdicao);
            Object.assign(objEdicao.value, req[0]);
        }else{
            objEdicao.value = criarManifTipo();
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.value.idlogin = globalStore.idlogin;
        modoEdicao.value = true;
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


function novoCadastro() {
    setEdicao(0);
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarDados(){
    let x = '';
    let r = Validar.texto(objEdicao.value.nmtipo, '\n-Informe nome');
    if (!r.ok) x += r.msg;
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


onMounted(lerDados);
</script>